import { B as e, C as t, D as n, E as r, F as i, H as a, I as o, M as s, N as c, O as l, P as u, R as d, T as f, U as p, W as m, c as h, d as g, f as _, g as v, h as y, j as b, k as x, m as S, p as C, r as w, s as ee, t as te, z as T } from "./useCollections-V5XMzAS9.js";
import { a as ne, i as re, n as E, r as ie, t as D } from "./languageStore-T5E15Nsa.js";
import { n as O } from "./sourceConversations-DveaTklB.js";
import { knowledgeActions as k } from "./knowledge.actions.js";
import { ApolloClient as ae, ApolloProvider as oe, InMemoryCache as se, createHttpLink as ce, from as le, useQuery as ue } from "@apollo/client";
import { Avatar as de, Banner as A, Box as j, Button as fe, ButtonList as M, CollapseCard as N, Divider as pe, DropdownButton as me, DropdownButtonContext as he, FlexBox as P, Icon as F, IconButton as ge, InputText as _e, Pagination as ve, Text as I, Timestamp as ye, Tooltip as be } from "@dixa/lib-shared-habla";
import { createPersistedQueryLink as xe } from "@apollo/client/link/persisted-queries";
import { RetryLink as Se } from "@apollo/client/link/retry";
import { config as Ce } from "lib-shared-backend-config";
import { Fragment as L, jsx as R, jsxs as z } from "react/jsx-runtime";
import B, { createContext as we, forwardRef as Te, lazy as V, useCallback as H, useEffect as U, useLayoutEffect as Ee, useMemo as De, useRef as W, useState as G } from "react";
import K from "classnames";
import { Sentry as Oe, SentryTeam as ke } from "lib-shared-sentry";
import { noop as Ae } from "ts-essentials";
import { ampli as q } from "lib-shared-tracking";
import { createPortal as je } from "react-dom";
import { renderToString as Me } from "react-dom/server";
import { useDispatch as Ne } from "react-redux";
import { usePagination as Pe } from "react-use-pagination";
// ../delivery-common/src/apolloClient.ts
var Fe = "beta";
function Ie() {
	return ce({ uri: `${Ce.url.knowledgeApi}/delivery/api/${Fe}/graphql` });
}
var Le = new se({ typePolicies: {
	ArticleSearchQueries: { merge: (e, t, { mergeObjects: n }) => n(e, t) },
	Query: { fields: {
		suggestions: { merge: !0 },
		knowledgeBase: { merge: !0 }
	} }
} }), Re;
function ze() {
	if (!Re) {
		let e = new Se({
			delay: {
				initial: 1e3,
				max: 1e4
			},
			attempts: { max: 3 }
		}), t = le([
			xe({
				sha256: a,
				useGETForHashedQueries: !1
			}),
			T(),
			e,
			Ie()
		].filter(Boolean));
		Re = new ae({
			link: t,
			cache: Le,
			assumeImmutableResults: !0,
			defaultOptions: { query: { canonizeResults: !0 } },
			connectToDevTools: !0
		});
	}
	return Re;
}
// ../delivery-common/src/components/languagePickerDropdown.tsx
function Be({ languageData: e, selectedLanguageId: t, setSelectedLanguageId: n }) {
	let r = e.defaultLanguage.languageId, i = [e.defaultLanguage, ...e.enabledLanguages.filter((e) => e.languageId !== r)];
	return /* @__PURE__ */ R(he.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ R(M, { children: i.map((i) => /* @__PURE__ */ z(M.Item, {
		onClick: (t) => {
			t.preventDefault(), t.stopPropagation(), e(), n(i.languageId);
		},
		isSelected: t === i.languageId,
		children: [i.description, i.languageId === r ? " (Default)" : ""]
	}, i.languageId)) }) });
}
// ../utils/src/components/bugTracking.tsx
function Ve({ children: e, fallback: t }) {
	function n(e) {
		Oe.captureException(e, { tags: { team: ke.Knowledge } });
	}
	return /* @__PURE__ */ R(Oe.ErrorBoundary, {
		fallback: t,
		onError: n,
		children: e
	});
}
var He = { message: "_message_8a2au_1" };
// ../utils/src/components/knowledgeErrorPlaceholder.tsx
function Ue({ message: e }) {
	return /* @__PURE__ */ R(I.Paragraph, {
		className: He.message,
		variant: "4",
		subdued: !0,
		children: e || "Something went wrong, please reload and try again. If this issue persists, please contact support."
	});
}
// ../../../node_modules/just-debounce-it/index.mjs
var We = Ge;
function Ge(e, t, n) {
	var r = null, i = null, a = function() {
		r &&= (clearTimeout(r), i = null, null);
	}, o = function() {
		var e = i;
		a(), e && e();
	}, s = function() {
		if (!t) return e.apply(this, arguments);
		var o = this, s = arguments, c = n && !r;
		if (a(), i = function() {
			e.apply(o, s);
		}, r = setTimeout(function() {
			if (r = null, !c) {
				var e = i;
				return i = null, e();
			}
		}, t), c) return i();
	};
	return s.cancel = a, s.flush = o, s;
}
// ../utils/src/string.ts
var Ke = 3;
function qe(e) {
	return e.length >= Ke;
}
// ../delivery-common/src/hooks/useDebounce.ts
function Je(e, t) {
	let [n, r] = G(e);
	return U(() => {
		let n = setTimeout(() => r(e), t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}
// src/hooks/useSuggestions/useSearchByConversationId.ts
function Ye({ conversationTags: e, conversationText: t, queueId: n, skip: r, selectedLanguageId: a }) {
	let { currentConversationId: o } = v(S), s = Je(t, 500), c = {
		csid: o,
		languageId: a,
		limit: 30
	}, { data: l, loading: u, error: d, refetch: f, variables: p } = i({
		notifyOnNetworkStatusChange: !0,
		fetchPolicy: "cache-and-network",
		errorPolicy: "all",
		variables: c,
		skip: r || !n
	}), m = JSON.stringify(c) === JSON.stringify(p), h = u && (!l || !m), g = W(e);
	U(() => {
		let t;
		return g.current !== e && (g.current = e, n && (t = setTimeout(() => {
			f();
		}, 1e3))), () => {
			clearTimeout(t);
		};
	}, [
		s,
		e,
		f,
		n
	]);
	let _ = l?.suggestions.conversation?.articles, y = _?.searchMethodsUsed || [], x = y.length >= 2 && y[0] !== b.Tags, C = y && e.length ? x : !1, w = d?.graphQLErrors?.some(({ extensions: e }) => e?.cause === "QUEUE_NO_COLLECTIONS") ?? !1, ee = d?.graphQLErrors?.some(({ extensions: e }) => e?.cause === "CONVERSATION_NO_QUEUE") ?? !1;
	return {
		suggestions: _?.results,
		loading: h,
		error: d,
		unableToFindTaggedSuggestions: C,
		unableToFindLinkedCollections: w,
		conversationNoQueue: ee
	};
}
// ../delivery-common/src/hooks/useSearchQueryEvent.ts
function Xe() {
	let [e] = d();
	return ({ languageId: t, searchTerms: n, origin: r, searchResults: i }) => {
		let a = (/* @__PURE__ */ new Date()).valueOf(), o = window.location.href;
		return e({ variables: {
			searchResults: i,
			searchInput: {
				languageId: t,
				searchTerms: n
			},
			ctx: {
				createdAt: a,
				origin: r,
				pageUrl: o
			}
		} });
	};
}
// src/hooks/useSuggestions/useSearchByTerm.ts
function Ze({ searchTerm: e, skip: t, queueId: n, selectedLanguageId: r }) {
	let i = Xe(), a = o({
		variables: {
			id: n,
			type: x.Queue
		},
		skip: t
	}), { currentConversationId: s } = v(S), l = a.data?.externalResource?.linkedCollections.map((e) => e.id) || [], u = t || !qe(e) || !a.data || l.length === 0, d = {
		languageId: r,
		limit: 30,
		searchTerms: e,
		collectionIds: l
	}, { data: f, loading: p, variables: m, error: h } = c({
		notifyOnNetworkStatusChange: !0,
		fetchPolicy: "cache-and-network",
		variables: d,
		skip: u,
		onCompleted: (t) => {
			i({
				languageId: r,
				searchTerms: e,
				origin: { suggestions: { csid: s } },
				searchResults: t.suggestions.articleSearch.byTerms.results.map((e) => e.id)
			}), q.knowledgeArticlesSearchByTermSubmitted({
				deliveryId: s.toString(),
				source: "conversation-ui"
			});
		}
	}), g = JSON.stringify(d) === JSON.stringify(m), _ = p && (!f || !g);
	return u ? {
		suggestions: void 0,
		error: void 0,
		loading: !1
	} : {
		suggestions: f?.suggestions.articleSearch.byTerms?.results,
		error: h,
		loading: _
	};
}
// src/hooks/useSuggestions/index.ts
function Qe({ searchTerm: e, conversationTags: t, conversationText: n, queueId: r, selectedLanguageId: i }) {
	let a = qe(e), o = !r, { suggestions: s, loading: c, error: l, unableToFindTaggedSuggestions: u, unableToFindLinkedCollections: d, conversationNoQueue: f } = Ye({
		conversationTags: t,
		conversationText: n,
		queueId: r,
		skip: a,
		selectedLanguageId: i
	}), { suggestions: p, loading: m, error: h } = Ze({
		searchTerm: e,
		queueId: r,
		skip: !a,
		selectedLanguageId: i
	});
	return o ? {
		suggestions: [],
		loading: !1,
		error: void 0,
		unableToFindTaggedSuggestions: !1,
		unableToFindLinkedCollections: !1,
		noQueue: !0
	} : a ? {
		suggestions: (p === void 0 || p.length === 0) && s ? s : p,
		loading: m,
		error: h,
		unableToFindTaggedSuggestions: !1,
		unableToFindLinkedCollections: !1,
		noQueue: !1
	} : {
		suggestions: (s === void 0 || s.length === 0) && p ? p : s,
		loading: c,
		error: f ? void 0 : l,
		unableToFindTaggedSuggestions: u,
		unableToFindLinkedCollections: d,
		noQueue: f
	};
}
// ../../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var $e = /* @__PURE__ */ p(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), et = /* @__PURE__ */ p(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, ee = s, te = n, T = d, ne = i, re = h, E = m, ie = r, D = o, O = a, k = f, ae = !1;
		function oe(e) {
			return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), se(e) || x(e) === l;
		}
		function se(e) {
			return x(e) === u;
		}
		function ce(e) {
			return x(e) === c;
		}
		function le(e) {
			return x(e) === s;
		}
		function ue(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function de(e) {
			return x(e) === d;
		}
		function A(e) {
			return x(e) === i;
		}
		function j(e) {
			return x(e) === h;
		}
		function fe(e) {
			return x(e) === m;
		}
		function M(e) {
			return x(e) === r;
		}
		function N(e) {
			return x(e) === o;
		}
		function pe(e) {
			return x(e) === a;
		}
		function me(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = ee, e.Element = te, e.ForwardRef = T, e.Fragment = ne, e.Lazy = re, e.Memo = E, e.Portal = ie, e.Profiler = D, e.StrictMode = O, e.Suspense = k, e.isAsyncMode = oe, e.isConcurrentMode = se, e.isContextConsumer = ce, e.isContextProvider = le, e.isElement = ue, e.isForwardRef = de, e.isFragment = A, e.isLazy = j, e.isMemo = fe, e.isPortal = M, e.isProfiler = N, e.isStrictMode = pe, e.isSuspense = me, e.isValidElementType = b, e.typeOf = x;
	})();
})), tt = /* @__PURE__ */ p(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? $e() : et();
})), nt = /* @__PURE__ */ p(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), rt = /* @__PURE__ */ p(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), it = /* @__PURE__ */ p(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), at = /* @__PURE__ */ p(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = rt(), i = {}, a = it();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), ot = /* @__PURE__ */ p(((e, t) => {
	var n = tt(), r = nt(), i = rt(), a = it(), o = at(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: te(),
			objectOf: w,
			oneOf: C,
			oneOfType: ee,
			shape: ne,
			exact: re
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					}
					if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (D(s) !== e) {
					var c = O(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = D(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = D(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = D(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = ae(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return O(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = D(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function ee(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + k(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function te() {
			function e(e, t, n, r, i) {
				return E(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function T(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function ne(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = D(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return T(r, a, o, l, O(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function re(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = D(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return T(o, s, c, d, O(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function E(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(E);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!E(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !E(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function ie(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function D(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : ie(t, e) ? "symbol" : t;
		}
		function O(e) {
			if (e == null) return "" + e;
			var t = D(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function k(e) {
			var t = O(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function ae(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), st = /* @__PURE__ */ p(((e, t) => {
	var n = rt();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), J = /* @__PURE__ */ m((/* @__PURE__ */ p(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = tt();
		t.exports = ot()(n.isElement, !0);
	} else t.exports = st()();
})))()), ct = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function lt(e, t) {
	return e(t = { exports: {} }, t.exports), t.exports;
}
var ut = lt((function(e) {
	(function(t) {
		var n = function(e, t, r) {
			if (!c(t) || u(t) || d(t) || f(t) || s(t)) return t;
			var i, a = 0, o = 0;
			if (l(t)) for (i = [], o = t.length; a < o; a++) i.push(n(e, t[a], r));
			else for (var p in i = {}, t) Object.prototype.hasOwnProperty.call(t, p) && (i[e(p, r)] = n(e, t[p], r));
			return i;
		}, r = function(e) {
			return p(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, (function(e, t) {
				return t ? t.toUpperCase() : "";
			}))).substr(0, 1).toLowerCase() + e.substr(1);
		}, i = function(e) {
			var t = r(e);
			return t.substr(0, 1).toUpperCase() + t.substr(1);
		}, a = function(e, t) {
			return function(e, t) {
				var n = (t ||= {}).separator || "_", r = t.split || /(?=[A-Z])/;
				return e.split(r).join(n);
			}(e, t).toLowerCase();
		}, o = Object.prototype.toString, s = function(e) {
			return typeof e == "function";
		}, c = function(e) {
			return e === Object(e);
		}, l = function(e) {
			return o.call(e) == "[object Array]";
		}, u = function(e) {
			return o.call(e) == "[object Date]";
		}, d = function(e) {
			return o.call(e) == "[object RegExp]";
		}, f = function(e) {
			return o.call(e) == "[object Boolean]";
		}, p = function(e) {
			return (e -= 0) == e;
		}, m = function(e, t) {
			var n = t && "process" in t ? t.process : t;
			return typeof n == "function" ? function(t, r) {
				return n(t, e, r);
			} : e;
		}, h = {
			camelize: r,
			decamelize: a,
			pascalize: i,
			depascalize: a,
			camelizeKeys: function(e, t) {
				return n(m(r, t), e);
			},
			decamelizeKeys: function(e, t) {
				return n(m(a, t), e, t);
			},
			pascalizeKeys: function(e, t) {
				return n(m(i, t), e);
			},
			depascalizeKeys: function() {
				return this.decamelizeKeys.apply(this, arguments);
			}
		};
		e.exports ? e.exports = h : t.humps = h;
	})(ct);
})).decamelize, dt = function(e) {
	if (Array.isArray(e)) return e;
}, ft = function(e, t) {
	if (typeof Symbol < "u" && Symbol.iterator in Object(e)) {
		var n = [], r = !0, i = !1, a = void 0;
		try {
			for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0);
		} catch (e) {
			i = !0, a = e;
		} finally {
			try {
				r || s.return == null || s.return();
			} finally {
				if (i) throw a;
			}
		}
		return n;
	}
}, pt = function(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}, mt = function(e, t) {
	if (e) {
		if (typeof e == "string") return pt(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pt(e, t) : void 0;
	}
}, ht = function() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}, gt = function(e, t) {
	return dt(e) || ft(e, t) || mt(e, t) || ht();
}, _t = lt((function(e) {
	function t() {
		return e.exports = t = Object.assign || function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, t.apply(this, arguments);
	}
	e.exports = t;
})), vt = function(e, t) {
	if (e == null) return {};
	var n, r, i = {}, a = Object.keys(e);
	for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
	return i;
}, yt = function(e, t) {
	if (e == null) return {};
	var n, r, i = vt(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}, bt = we(null);
function xt(e) {
	var t = e.children, n = t === void 0 ? "" : t, r = yt(e, ["children"]);
	return typeof n != "string" && (n = Me(n)), B.createElement("template", _t({}, r, { dangerouslySetInnerHTML: { __html: n } }));
}
function St(e) {
	var t = e.root, n = e.children;
	return je(n === void 0 ? null : n, t);
}
function Ct(e) {
	var t = Te((function(t, n) {
		var r, i, a = t.mode, o = a === void 0 ? "open" : a, s = t.delegatesFocus, c = s !== void 0 && s, l = t.styleSheets, u = l === void 0 ? [] : l, d = t.ssr, f = d !== void 0 && d, p = t.children, m = yt(t, [
			"mode",
			"delegatesFocus",
			"styleSheets",
			"ssr",
			"children"
		]), h = (i = W((r = n) && r.current), U((function() {
			r && (r.current = i.current);
		}), [r]), i), g = gt(G(null), 2), _ = g[0], v = g[1], y = `node_${o}${c}`;
		return Ee((function() {
			if (h.current) try {
				if (typeof n == "function" && n(h.current), f) {
					var e = h.current.shadowRoot;
					v(e);
					return;
				}
				var t = h.current.attachShadow({
					mode: o,
					delegatesFocus: c
				});
				u.length > 0 && (t.adoptedStyleSheets = u), v(t);
			} catch (e) {
				(function(e) {
					var t = e.error, n = e.styleSheets, r = e.root;
					switch (t.name) {
						case "NotSupportedError":
							n.length > 0 && (r.adoptedStyleSheets = n);
							break;
						default: throw t;
					}
				})({
					error: e,
					styleSheets: u,
					root: _
				});
			}
		}), [
			n,
			h,
			u
		]), B.createElement(B.Fragment, null, B.createElement(e.tag, _t({
			key: y,
			ref: h
		}, m), (_ || f) && B.createElement(bt.Provider, { value: _ }, f ? B.createElement(xt, {
			shadowroot: o,
			shadowrootmode: o
		}, e.render({
			root: _,
			ssr: f,
			children: p
		})) : B.createElement(St, { root: _ }, e.render({
			root: _,
			ssr: f,
			children: p
		})))));
	}));
	return t.propTypes = {
		mode: J.default.oneOf(["open", "closed"]),
		delegatesFocus: J.default.bool,
		styleSheets: J.default.arrayOf(J.default.instanceOf(globalThis.CSSStyleSheet)),
		ssr: J.default.bool,
		children: J.default.node
	}, t;
}
xt.propTypes = { children: J.default.oneOfType([J.default.string, J.default.node]) }, St.propTypes = {
	root: J.default.object.isRequired,
	children: J.default.node
};
var wt = /* @__PURE__ */ new Map();
function Tt() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(e) {
		return e.children;
	};
	return new Proxy(e, { get: function(e, r) {
		var i = ut(r, { separator: "-" }), a = `${t}-${i}`;
		return wt.has(a) || wt.set(a, Ct({
			tag: i,
			render: n
		})), wt.get(a);
	} });
}
var Et = Tt();
// ../article/src/utils.ts
function Dt({ cssVersion: e = "1.3.0", noREMs: t = !1 } = {}) {
	return `https://staticfiles.dixa.io/knowledge/css/article/${e === "1.0.0" || e === "1.1.0" ? "1.3.0" : e}/${t ? "article-no-rems.css" : "article.css"}`;
}
// ../article/src/customElements.ts
function Ot() {
	window.customElements.get("html-block") || window.customElements.define("html-block", kt);
}
var kt = class extends HTMLElement {
	static observedAttributes = ["use-article-styles", "src"];
	divElement;
	styleElement;
	constructor() {
		super();
		let e = this.attachShadow({ mode: "open" });
		this.divElement = document.createElement("div"), this.divElement.className = "article", this.divElement.style.paddingBottom = "unset", this.divElement.style.maxInlineSize = "unset", e.appendChild(this.divElement), this.styleElement = document.createElement("link"), this.styleElement.rel = "stylesheet", this.styleElement.type = "text/css", this.styleElement.href = Dt({ noREMs: !0 });
	}
	updateSrc(e) {
		try {
			let t = decodeURIComponent(e);
			this.divElement.innerHTML = t;
		} catch (e) {
			console.error("Error decoding src in HtmlBlock", e);
		}
	}
	updateStyle(e) {
		let t = this.shadowRoot;
		t && (e === "true" ? t.contains(this.styleElement) || t.appendChild(this.styleElement) : t.contains(this.styleElement) && t.removeChild(this.styleElement));
	}
	attributeChangedCallback(e, t, n) {
		e === "src" && this.updateSrc(n), e === "use-article-styles" && this.updateStyle(n);
	}
}, At = 500;
function jt({ articleId: e, articleCollectionId: t, html: n, className: r, onClickInterlink: i, withCSS: a = !0 }) {
	let o = W(null), s = (e) => {
		let n = e.target;
		if (Nt(n)) {
			e.preventDefault();
			return;
		}
		let r = n.closest("[data-knowledge-article]")?.getAttribute("data-knowledge-article");
		r ? (e.preventDefault(), e.stopPropagation(), i && i({
			articleId: r,
			articleCollectionId: t
		})) : Pt(o.current, e);
	}, c = H((t) => {
		setTimeout(() => {
			let n = e.match("#");
			if (t === null || !n) return;
			let r = e.split("#")[1] || "", i = t.querySelector(`[id="${r}"]`) || t.querySelector(`[name="${r}"]`);
			i && i.scrollIntoView({ behavior: "smooth" });
		}, At);
	}, [e]);
	return U(() => {
		Ot();
	}, []), /* @__PURE__ */ z(L, { children: [a && /* @__PURE__ */ R("link", {
		rel: "stylesheet",
		type: "text/css",
		href: Dt({ noREMs: !0 })
	}), /* @__PURE__ */ R("div", {
		ref: c,
		children: /* @__PURE__ */ R("div", {
			className: K("article-body", r, "article"),
			style: {
				padding: 0,
				marginBottom: 0
			},
			dangerouslySetInnerHTML: { __html: n },
			ref: o,
			onClick: s
		})
	})] });
}
function Mt(e) {
	return /* @__PURE__ */ R(Et.div, {
		className: K("article-container", e.outerClassName),
		style: e.outerStyle,
		children: /* @__PURE__ */ R(jt, { ...e })
	});
}
function Nt(e) {
	let t = e.closest("img.image-preview, img.image-inline");
	if (!t || e.closest("a")) return !1;
	let n = t.currentSrc || t.src;
	if (!n) return !1;
	let r = new URL(n);
	return r.searchParams.delete("width"), window.open(r.href, "_blank", "noopener"), !0;
}
function Pt(e, t) {
	let n = t.target.closest("a")?.getAttribute("href") ?? null;
	if (n) {
		if (t.preventDefault(), t.stopPropagation(), n.indexOf("#") !== 0) window.open(n, "_blank", "noopener noreferrer");
		else if (n === "#") e.scrollIntoView({ behavior: "smooth" });
		else {
			try {
				let t = n.slice(1), r = `[name="${t}"]`, i = `[id="${t}"]`, a = e.querySelector(r) || e.querySelector(i);
				if (a) {
					a.scrollIntoView({ behavior: "smooth" });
					return;
				}
			} catch {}
			try {
				let t = e.querySelector(n);
				if (t) {
					t.scrollIntoView({ behavior: "smooth" });
					return;
				}
			} catch {}
		}
	}
}
// ../../../node_modules/react-use/esm/useMountedState.js
function Ft() {
	var e = W(!1), t = H(function() {
		return e.current;
	}, []);
	return U(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
// ../../../node_modules/react-use/esm/useSetState.js
var It = function(e) {
	e === void 0 && (e = {});
	var t = G(e), n = t[0], r = t[1];
	return [n, H(function(e) {
		r(function(t) {
			return Object.assign({}, t, e instanceof Function ? e(t) : e);
		});
	}, [])];
}, Lt = /* @__PURE__ */ p(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default: t = null;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), Rt = /* @__PURE__ */ m((/* @__PURE__ */ p(((e, t) => {
	var n = Lt(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) {
					if (n.preventDefault(), n.clipboardData === void 0) {
						o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
						var i = r[t.format] || r.default;
						window.clipboardData.setData(i, e);
					} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				}
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})))()), zt = function() {
	var e = Ft(), t = It({
		value: void 0,
		error: void 0,
		noUserInteraction: !0
	}), n = t[0], r = t[1];
	return [n, H(function(t) {
		if (e()) {
			var n, i;
			try {
				if (typeof t != "string" && typeof t != "number") {
					var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				if (t === "") {
					var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				i = t.toString(), n = (0, Rt.default)(i), r({
					value: i,
					error: void 0,
					noUserInteraction: n
				});
			} catch (e) {
				r({
					value: i,
					error: e,
					noUserInteraction: n
				});
			}
		}
	}, [])];
}, Bt = 3e3;
function Vt(e) {
	let [t, n] = zt(), [r, i] = G(!1);
	return U(() => {
		let n = null;
		return t.value && (i(!0), n = setTimeout(() => {
			i(!1);
		}, e ?? Bt)), () => {
			n && clearTimeout(n);
		};
	}, [t, e]), {
		clipboard: t,
		setClipboard: n,
		timedClipboardIndicator: r
	};
}
var Ht = {
	copyIcon: "_copyIcon_4vozc_1",
	openIcon: "_openIcon_4vozc_2",
	copied: "_copied_4vozc_6"
};
// ../utils/src/colors.ts
function Ut(e) {
	return e.length === 9 ? e.slice(0, 7) : e;
}
// ../utils/src/constants.ts
var Wt = "#45587C", Gt = { collectionIcon: "_collectionIcon_10v8g_1" };
// ../delivery-common/src/components/collectionIcon.tsx
function Kt({ color: e = Wt }) {
	let t = Ut(e);
	return /* @__PURE__ */ R(j, {
		as: "span",
		style: { backgroundColor: `${t}1A` },
		borderRadius: "100",
		children: /* @__PURE__ */ R(F, {
			name: "copy",
			size: 20,
			className: Gt.collectionIcon,
			style: {
				fill: t,
				color: t
			}
		})
	});
}
// ../delivery-common/src/components/articleActionButtons/components/dropdownContent.tsx
var qt = ({ articleId: e, languageId: t, availableAt: { helpCenters: n, internalKbs: r }, callback: i }) => /* @__PURE__ */ z(L, { children: [n.map(({ name: e, url: t }) => {
	let n = new URL(t).hostname;
	return /* @__PURE__ */ R(Jt, {
		url: t,
		callback: i,
		name: e,
		hostname: n,
		icon: "question"
	}, t);
}), r.map(({ name: n, collectionId: r, iconColor: a }) => {
	let { path: o, search: s } = re.internalKBArticle({
		collectionId: r,
		articleId: e,
		languageId: t
	}), c = `${window.location.origin}${o}${s ? `?${s}` : ""}`;
	return /* @__PURE__ */ R(Jt, {
		url: c,
		callback: i,
		name: n,
		hostname: "Internal Knowledge Base",
		icon: "file-text",
		iconColor: a
	}, c);
})] }), Jt = ({ callback: e, hostname: t, icon: n, iconColor: r, name: i, url: a, faviconUrl: o }) => /* @__PURE__ */ R(M.Item, {
	onClick: () => e(a),
	buttonProps: { style: { cursor: "pointer" } },
	children: /* @__PURE__ */ z(P, {
		as: "span",
		flexDirection: "row",
		alignItems: "center",
		gap: "300",
		children: [o ? /* @__PURE__ */ R("img", {
			src: o,
			alt: `Favicon for ${i}`
		}) : r ? /* @__PURE__ */ R(Kt, { color: r }) : /* @__PURE__ */ R(P, {
			as: "span",
			padding: "200",
			background: "neutral.200",
			borderRadius: "100",
			children: /* @__PURE__ */ R(F, {
				name: n,
				size: 16
			})
		}), /* @__PURE__ */ z(P, {
			as: "span",
			flexDirection: "column",
			alignItems: "flex-start",
			children: [i, t && /* @__PURE__ */ R(I.Paragraph, {
				as: "span",
				variant: "4",
				subdued: !0,
				children: t
			})]
		})]
	})
}, a), Yt = ({ availableAt: e, articleId: t, languageId: n, setCopiedUrl: r }) => /* @__PURE__ */ z(M, { children: [/* @__PURE__ */ R(M.Item, { children: /* @__PURE__ */ R(I.Paragraph, {
	as: "span",
	variant: "4",
	subdued: !0,
	children: "Copy link to article in..."
}) }), /* @__PURE__ */ R(qt, {
	articleId: t,
	availableAt: e,
	languageId: n,
	callback: (e) => r(e)
})] }), Xt = ({ articleId: e, availableAt: t, languageId: n }) => /* @__PURE__ */ z(M, { children: [/* @__PURE__ */ R(M.Item, { children: /* @__PURE__ */ R(I.Paragraph, {
	as: "span",
	variant: "4",
	subdued: !0,
	children: "Open article in..."
}) }), /* @__PURE__ */ R(qt, {
	availableAt: t,
	languageId: n,
	articleId: e,
	callback: (e) => window.open(e, "_blank")
})] }), Zt = ({ articleId: e, availableAt: t, buttonLabel: n, languageId: r, buttonVariant: i, showOpenOptions: a = !0 }) => {
	let { timedClipboardIndicator: o, setClipboard: s } = Vt(), { helpCenters: c } = t, l = o ? "check-circle-filled" : "link", u = K(Ht.copyIcon, { [Ht.copied]: o }), d = a && c.length > 0;
	return c.length === 0 ? /* @__PURE__ */ R(L, {}) : /* @__PURE__ */ z(P, {
		gap: "100",
		alignItems: "center",
		children: [/* @__PURE__ */ R(be, {
			content: o ? "Copied!" : c.length > 1 ? "Copy link..." : "Copy link",
			side: "top",
			children: /* @__PURE__ */ R(me, {
				noArrow: !n,
				onClick: (e) => {
					e.preventDefault(), e.stopPropagation();
				},
				buttonProps: {
					variant: i,
					style: { padding: "var(--dixa-size-spacer-200)" }
				},
				dropdown: /* @__PURE__ */ R(Yt, {
					articleId: e,
					availableAt: t,
					setCopiedUrl: s,
					languageId: r
				}),
				show: !o && void 0,
				children: n ? /* @__PURE__ */ z(P, {
					gap: "200",
					children: [
						/* @__PURE__ */ R(F, {
							className: u,
							name: l
						}),
						" ",
						n
					]
				}) : /* @__PURE__ */ R(F, {
					className: u,
					name: l
				})
			})
		}), d ? /* @__PURE__ */ R(be, {
			content: c.length > 1 ? "Open..." : "Open",
			side: "top",
			children: /* @__PURE__ */ R(me, {
				noArrow: !0,
				onClick: (e) => {
					e.preventDefault(), e.stopPropagation();
				},
				buttonProps: {
					variant: i,
					style: { padding: "var(--dixa-size-spacer-200)" }
				},
				dropdown: /* @__PURE__ */ R(Xt, {
					articleId: e,
					availableAt: t,
					languageId: r
				}),
				children: /* @__PURE__ */ R(F, {
					name: "external-link",
					className: Ht.openIcon
				})
			})
		}) : null]
	});
};
// ../delivery-common/src/hooks/useArticleRatingEvent.ts
function Qt() {
	let [e] = s();
	return { articleRating: {
		sendPositiveEvent: H(({ articleId: t, languageId: n, origin: r }) => {
			let i = (/* @__PURE__ */ new Date()).valueOf(), a = {
				articleId: t,
				languageId: n,
				ctx: {
					origin: r,
					pageUrl: window.location.href,
					createdAt: i
				}
			};
			return e({ variables: {
				...a,
				rating: l.Positive
			} });
		}, [e]),
		sendNegativeEvent: H(({ articleId: t, languageId: n, origin: r }) => {
			let i = (/* @__PURE__ */ new Date()).valueOf(), a = {
				articleId: t,
				languageId: n,
				ctx: {
					origin: r,
					pageUrl: window.location.href,
					createdAt: i
				}
			};
			return e({ variables: {
				...a,
				rating: l.Negative
			} });
		}, [e])
	} };
}
var $t = {
	button: "_button_sgpuo_1",
	positive: "_positive_sgpuo_4",
	negative: "_negative_sgpuo_8"
}, en = y(), tn = (e) => {
	en.add(e);
};
function nn({ articleId: e, languageId: t, origin: n }) {
	let { articleRating: { sendNegativeEvent: r, sendPositiveEvent: i } } = Qt(), a = v(en), o = () => {
		i({
			articleId: e,
			languageId: t,
			origin: n
		}), tn(e);
	}, s = () => {
		r({
			articleId: e,
			languageId: t,
			origin: n
		}), tn(e);
	}, c = n.suggestions ? "3" : "1";
	return a.has(e) ? /* @__PURE__ */ R(P, {
		gap: "300",
		justifyContent: "center",
		alignItems: "center",
		margin: "400 0 0",
		children: /* @__PURE__ */ R(I.Paragraph, {
			variant: c,
			children: "Thank you for your feedback."
		})
	}) : /* @__PURE__ */ z(P, {
		gap: "300",
		justifyContent: "center",
		alignItems: "center",
		margin: "400 0 0",
		children: [/* @__PURE__ */ R(I.Paragraph, {
			variant: c,
			children: "Was this helpful?"
		}), /* @__PURE__ */ z(P, {
			gap: "200",
			children: [/* @__PURE__ */ R(ge, {
				className: K($t.button, $t.positive),
				type: "button",
				variant: "tertiary",
				onClick: o,
				icon: "thumbs-up"
			}), /* @__PURE__ */ R(ge, {
				className: K($t.button, $t.negative),
				type: "button",
				variant: "tertiary",
				onClick: s,
				icon: "thumbs-down"
			})]
		})]
	});
}
// ../delivery-common/src/hooks/useArticleViewEvent.ts
function rn() {
	let [e] = u();
	return ({ articleId: t, languageId: n, origin: r }) => {
		let i = (/* @__PURE__ */ new Date()).valueOf(), a = window.location.href;
		return e({ variables: {
			articleId: t,
			languageId: n,
			ctx: {
				origin: r,
				pageUrl: a,
				createdAt: i
			}
		} });
	};
}
// ../delivery-common/src/hooks/useSuggestionArticle.ts
function an(e) {
	return e.split("#")[0];
}
function on({ id: e, languageId: t, collectionId: r, onCompleted: i }) {
	if (!r) throw Error("useArticle > collectionId is required");
	let a = {
		languageId: t,
		id: an(e),
		collectionId: r
	}, o = ue(n, {
		fetchPolicy: "cache-and-network",
		notifyOnNetworkStatusChange: !0,
		variables: a,
		onCompleted: i
	}), s = o.data;
	s?.suggestions.article && (s = {
		...s,
		suggestions: {
			...s.suggestions,
			article: {
				...s.suggestions.article,
				id: e
			}
		}
	});
	let c = JSON.stringify(a) === JSON.stringify(o.variables), l = o.loading && (!o.data || !c);
	return {
		...o,
		data: s,
		loading: l
	};
}
var Y = {
	placeholder: "_placeholder_1w5gw_1",
	grow: "_grow_1w5gw_6",
	icon: "_icon_1w5gw_10",
	results: "_results_1w5gw_11",
	title: "_title_1w5gw_20",
	articleMeta: "_articleMeta_1w5gw_21",
	featuredImage: "_featuredImage_1w5gw_25",
	articleHeader: "_articleHeader_1w5gw_31"
}, X = {
	placeholder: "_placeholder_qx407_1",
	placeholderPagination: "_placeholderPagination_qx407_6",
	placeholderRow: "_placeholderRow_qx407_10",
	placeholderTitleWrapper: "_placeholderTitleWrapper_qx407_14",
	suggestionsNotFound: "_suggestionsNotFound_qx407_19",
	suggestionsNotFoundContent: "_suggestionsNotFoundContent_qx407_27",
	link: "_link_qx407_35",
	searchInput: "_searchInput_qx407_42",
	suggestionsNotFoundWrapper: "_suggestionsNotFoundWrapper_qx407_50"
};
// src/components/SuggestionList/SuggestionListPlaceholder.tsx
function sn(e) {
	return e === 0 ? 0 : e >= 6 ? 5 : e - 1;
}
var Z = () => /* @__PURE__ */ R(j, {
	height: "16px",
	width: "16px",
	className: X.placeholder
});
function cn() {
	return /* @__PURE__ */ z(P, {
		gap: "300",
		alignItems: "center",
		width: "100%",
		className: X.placeholderRow,
		children: [
			/* @__PURE__ */ R(j, {
				height: "36px",
				width: "4px",
				className: X.placeholder
			}),
			/* @__PURE__ */ z(P, {
				flexDirection: "column",
				gap: "5px",
				className: X.placeholderTitleWrapper,
				children: [/* @__PURE__ */ R(j, {
					height: "14px",
					width: "160px",
					className: X.placeholder
				}), /* @__PURE__ */ z(P, {
					gap: "4px",
					alignItems: "center",
					children: [
						/* @__PURE__ */ R(j, {
							height: "12px",
							width: "60px",
							className: X.placeholder
						}),
						/* @__PURE__ */ R(j, {
							height: "4px",
							width: "4px",
							className: X.placeholder
						}),
						/* @__PURE__ */ R(j, {
							height: "12px",
							width: "60px",
							className: X.placeholder
						})
					]
				})]
			}),
			/* @__PURE__ */ R(j, {
				height: "16px",
				width: "16px",
				className: X.placeholder
			}),
			/* @__PURE__ */ R(j, {
				height: "16px",
				width: "16px",
				className: X.placeholder
			})
		]
	});
}
function ln({ resultsCount: e }) {
	return e <= 6 ? /* @__PURE__ */ R(j, { style: { height: 8 } }) : /* @__PURE__ */ z(P, {
		gap: "300",
		justifyContent: "center",
		className: X.placeholderPagination,
		children: [
			/* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {})
		]
	});
}
var un = ({ resultsCount: e }) => {
	let t = sn(e), n = Array.from(Array(t));
	return /* @__PURE__ */ z(L, { children: [n.map((e, t) => /* @__PURE__ */ z(B.Fragment, { children: [/* @__PURE__ */ R(cn, {}), /* @__PURE__ */ R(pe, { size: "xSmall" })] }, t)), /* @__PURE__ */ R(cn, {})] });
};
function dn({ resultsCount: e }) {
	return /* @__PURE__ */ z(P, {
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ R(un, { resultsCount: e }), /* @__PURE__ */ R(ln, { resultsCount: e })]
	});
}
function fn({ description: e, headline: t }) {
	return /* @__PURE__ */ R(j, {
		className: X.suggestionsNotFoundWrapper,
		children: /* @__PURE__ */ R(A, {
			className: X.suggestionsNotFound,
			variant: "warning",
			headline: t,
			description: /* @__PURE__ */ R(I.Paragraph, {
				subdued: !0,
				variant: "4",
				className: X.suggestionsNotEnabledContent,
				children: e
			})
		})
	});
}
// src/components/Article/ArticleLoadingPlaceholder.tsx
function pn({ hasSmartReply: e }) {
	return /* @__PURE__ */ z(P, {
		width: "100%",
		padding: "0 0 28px",
		gap: "300",
		children: [
			/* @__PURE__ */ R(F, {
				className: Y.icon,
				name: "arrow-left"
			}),
			/* @__PURE__ */ R(j, {
				className: Y.grow,
				children: /* @__PURE__ */ R(I.Paragraph, {
					className: Y.results,
					variant: "3",
					children: "Results"
				})
			}),
			e && /* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {}),
			/* @__PURE__ */ R(Z, {})
		]
	});
}
function mn() {
	return /* @__PURE__ */ z(P, {
		flexDirection: "column",
		gap: "22px",
		children: [
			/* @__PURE__ */ R(j, {
				width: "160px",
				height: "16px",
				className: Y.placeholder
			}),
			/* @__PURE__ */ R(P, {
				flexDirection: "column",
				gap: "8px",
				children: Array.from([
					,
					,
					,
					,
				]).map((e, t) => /* @__PURE__ */ z(P, {
					gap: "6px",
					alignItems: "center",
					children: [/* @__PURE__ */ R(j, {
						width: "12px",
						height: "12px",
						className: Y.placeholder
					}), /* @__PURE__ */ R(j, {
						width: "80px",
						height: "8px",
						className: Y.placeholder
					})]
				}, t))
			}),
			/* @__PURE__ */ R(P, {
				flexDirection: "column",
				gap: "8px",
				children: Array.from(Array(11)).map((e, t) => /* @__PURE__ */ R(j, {
					width: "100%",
					height: "12px",
					className: Y.placeholder
				}, t))
			})
		]
	});
}
function hn({ hasSmartReply: e }) {
	return /* @__PURE__ */ z(j, {
		margin: "0 0 400",
		children: [/* @__PURE__ */ R(pn, { hasSmartReply: e }), /* @__PURE__ */ R(mn, {})]
	});
}
// src/components/Article/useSmartReplyResponse.ts
function gn({ onRequest: t, onSuccess: n, onError: r, onFinally: i }) {
	let [a, o] = G(void 0), [s, c] = G(!1), [l, u] = G(null);
	return {
		data: a,
		loading: s,
		error: l,
		onFetch: async (a) => {
			c(!0), u(null), o(void 0), t && t();
			try {
				let t = `${Ce.url.knowledgeCdn}/ai/api/beta/conversations/smart_responses`, r = await e(), i = await fetch(t, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: r
					},
					body: JSON.stringify(a)
				});
				if (!i.ok) {
					let e = await i.text();
					throw Error(e);
				}
				let s = await i.json();
				return o(s), n && n({ message: s.response }), s;
			} catch (e) {
				throw r && r({ errorMessage: e?.message || "" }), u(e), e;
			} finally {
				i && i(), c(!1);
			}
		}
	};
}
// src/components/Article/Article.tsx
function _n({ conversationId: e, articleId: t, languageId: n, availableAt: r, articleText: i, hasSmartReply: a }) {
	let o = Ne(), { loading: s, onFetch: c } = gn({
		onRequest: () => {
			q.smartConversationReplyButtonClicked({
				articleId: t,
				conversationId: e,
				knowledgeSource: "dixa"
			}), o(k.smartConversationResponseRequested());
		},
		onSuccess: ({ message: e }) => {
			o(k.smartConversationResponseReceived({ message: e }));
		},
		onError: ({ errorMessage: e }) => {
			o(k.smartConversationResponseError({ errorMessage: e }));
		},
		onFinally: () => {
			o(k.smartConversationResponseFinally());
		}
	});
	return /* @__PURE__ */ z(P, {
		className: Y.articleHeader,
		gap: "300",
		alignItems: "center",
		children: [/* @__PURE__ */ R(F, {
			className: Y.icon,
			name: "arrow-left",
			onClick: () => {
				e && _.clearCurrentArticle();
			}
		}), /* @__PURE__ */ z(P, {
			className: Y.grow,
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ R(I.Paragraph, {
				className: Y.results,
				variant: "3",
				children: "Results"
			}), /* @__PURE__ */ z(P, {
				gap: "100",
				alignItems: "center",
				children: [a && /* @__PURE__ */ R(be, {
					content: "Smart Conversation Reply",
					side: "top",
					children: /* @__PURE__ */ R(ge, {
						type: "button",
						variant: "tertiary",
						icon: "ai",
						isLoading: s,
						disabled: s,
						onClick: () => c({
							article_text: i,
							csid: e,
							refresh: !1
						})
					})
				}), /* @__PURE__ */ R(Zt, {
					articleId: t,
					availableAt: r,
					languageId: n,
					buttonVariant: "tertiary"
				})]
			})]
		})]
	});
}
function vn({ articleTitle: e }) {
	return /* @__PURE__ */ R(I.Heading, {
		className: Y.title,
		variant: "heading-1",
		color: "primary",
		children: e
	});
}
var yn = "var(--dixa-typography-color-tertiary)";
function bn({ article: e }) {
	if (!e) return null;
	let { updatedAt: t, parentCategory: n, tags: r } = e;
	return /* @__PURE__ */ z(P, {
		className: Y.articleMeta,
		gap: "8px",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ R(Sn, {
				iconName: "pen",
				children: /* @__PURE__ */ z(L, { children: [
					"Last updated",
					" ",
					/* @__PURE__ */ R(ye, {
						time: t / 1e3,
						relative: !0
					})
				] })
			}),
			/* @__PURE__ */ R(Sn, {
				iconName: "address-book",
				children: n?.title
			}),
			!!r.length && /* @__PURE__ */ R(Sn, {
				iconName: "tag",
				children: r.map((e) => e.name).join(", ")
			})
		]
	});
}
function xn({ id: e, languageId: t, collectionId: n, hasSmartReply: r }) {
	let { currentConversationId: i } = v(S), a = rn(), { error: o, loading: s, data: c } = on({
		id: e,
		languageId: t,
		collectionId: n,
		onCompleted: () => a({
			articleId: e,
			languageId: t,
			origin: { suggestions: { csid: i } }
		})
	}), l = ({ articleId: e, articleCollectionId: t }) => {
		i && _.setCurrentArticle({
			articleId: e,
			conversationId: i,
			articleCollectionId: t
		});
	};
	if (o) throw o;
	if (s) return /* @__PURE__ */ R(hn, { hasSmartReply: r });
	if (!c || !c.suggestions.article) return null;
	let u = c.suggestions.article.title;
	return /* @__PURE__ */ z(j, {
		margin: "0 0 400",
		children: [
			/* @__PURE__ */ R(_n, {
				conversationId: i,
				articleId: c.suggestions.article.id,
				availableAt: c.suggestions.article.availableAt,
				articleText: c.suggestions.article.content.html,
				hasSmartReply: r,
				languageId: t
			}),
			/* @__PURE__ */ R(vn, { articleTitle: u }),
			/* @__PURE__ */ R(bn, { article: c.suggestions.article }),
			/* @__PURE__ */ R(Mt, {
				articleId: c.suggestions.article.id,
				articleCollectionId: c.suggestions.article.collectionId,
				cssVersion: c.suggestions.article.content.cssVersion,
				html: c.suggestions.article.content.html,
				onClickInterlink: l
			}),
			/* @__PURE__ */ R(nn, {
				articleId: e,
				languageId: t,
				origin: { suggestions: { csid: i } }
			})
		]
	});
}
function Sn({ children: e, iconName: t }) {
	return /* @__PURE__ */ z(P, {
		gap: "4px",
		alignItems: "center",
		children: [/* @__PURE__ */ R(F, {
			size: 12,
			name: t,
			color: yn
		}), /* @__PURE__ */ R(j, { children: /* @__PURE__ */ R(I.Paragraph, {
			variant: "4",
			color: "tertiary",
			children: e
		}) })]
	});
}
var Cn = { title: "_title_1ck71_1" };
// src/components/Title/Title.tsx
function wn({ title: e }) {
	return /* @__PURE__ */ R(I.Heading, {
		className: Cn.title,
		color: "secondary",
		variant: "heading-3",
		children: e
	});
}
var Tn = { wrapper: "_wrapper_2j8wl_1" };
// src/components/ArticleContent/ArticleContent.tsx
function En({ articleTitle: e, articleTags: t, categoryTitle: n, className: r }) {
	return /* @__PURE__ */ z(P, {
		flexDirection: "column",
		className: K(Tn.wrapper, r),
		children: [/* @__PURE__ */ R(wn, { title: e }), /* @__PURE__ */ R(On, {
			categoryTitle: n,
			articleTags: t
		})]
	});
}
var Dn = {
	heading: "_heading_5efjl_1",
	icon: "_icon_5efjl_7"
};
// src/components/ArticleContent/CategoryTags.tsx
function On({ categoryTitle: e, articleTags: t }) {
	return /* @__PURE__ */ R(P, {
		alignItems: "center",
		style: { flexWrap: "nowrap" },
		children: /* @__PURE__ */ z(I.Heading, {
			className: Dn.heading,
			color: "tertiary",
			variant: "heading-4",
			children: [/* @__PURE__ */ R(kn, { categoryTitle: e }), /* @__PURE__ */ R(An, { tags: t })]
		})
	});
}
function kn({ categoryTitle: e }) {
	return e ? /* @__PURE__ */ z(P, {
		alignItems: "center",
		children: [
			/* @__PURE__ */ R(F, {
				name: "folder",
				size: 12,
				style: { color: "var(--dixa-color-neutral-500)" },
				className: Dn.icon
			}),
			/* @__PURE__ */ R("span", { children: e }),
			/* @__PURE__ */ R("span", { children: "\xA0" })
		]
	}) : null;
}
function An({ tags: e }) {
	return e.length ? /* @__PURE__ */ z(P, {
		alignItems: "center",
		children: [/* @__PURE__ */ R(F, {
			name: "folder",
			size: 12,
			style: { color: "var(--dixa-color-neutral-500)" },
			className: Dn.icon
		}), /* @__PURE__ */ R("span", { children: e.join(", ") })]
	}) : null;
}
var jn = {
	article: "_article_p5amd_1",
	hover: "_hover_p5amd_6",
	articleRadioInputWrapper: "_articleRadioInputWrapper_p5amd_13"
};
// src/components/ArticleRow/ArticleRow.tsx
function Mn({ article: e }) {
	let { title: t, parentCategory: n, tags: r, id: i, collectionId: a, availableAt: o } = e, { currentConversationId: s } = v(S), { selectedLanguageId: c } = v(E);
	return /* @__PURE__ */ z(P, {
		className: jn.article,
		as: "article",
		onClick: () => _.setCurrentArticle({
			articleId: i,
			conversationId: s,
			articleCollectionId: a
		}),
		maxWidth: "100%",
		children: [/* @__PURE__ */ R(En, {
			className: jn.hover,
			articleTitle: t,
			articleTags: r.map((e) => e.name),
			categoryTitle: n?.title || ""
		}), /* @__PURE__ */ R(Zt, {
			articleId: e.id,
			availableAt: o,
			languageId: c,
			buttonVariant: "tertiary"
		})]
	});
}
var Q = {
	ul: "_ul_1pkwx_1",
	divider: "_divider_1pkwx_7",
	paginationWrapper: "_paginationWrapper_1pkwx_11",
	paginationStyles: "_paginationStyles_1pkwx_15",
	paginationStyles__multiplePages: "_paginationStyles__multiplePages_1pkwx_19",
	aiButton: "_aiButton_1pkwx_23"
};
// src/components/SuggestionList/ArticleSuggestionList.tsx
function Nn({ suggestions: e, beforeSlot: t }) {
	return /* @__PURE__ */ z(P, {
		className: Q.ul,
		as: "ul",
		gap: "300",
		flexDirection: "column",
		children: [t, e.map((t, n) => /* @__PURE__ */ z(j, {
			as: "li",
			children: [/* @__PURE__ */ R(Mn, { article: t }), n + 1 < e.length && /* @__PURE__ */ R(pe, {
				className: Q.divider,
				size: "xSmall"
			})]
		}, t.id))]
	});
}
// src/components/SuggestionList/SuggestionList.tsx
var Pn = V(() => import("./articleDraftModal-DidSx37X.js").then((e) => ({ default: e.ArticleDraftModal }))), Fn = V(() => import("./articleDraftModal-DidSx37X.js").then((e) => ({ default: e.ArticleDraftRequestedModal }))), In = V(() => import("./articleDraftModal-DidSx37X.js").then((e) => ({ default: e.ArticleDraftFailedModal }))), Ln = V(() => import("./articleDraftModal-DidSx37X.js").then((e) => ({ default: e.ArticleDraftCustomizeModal }))), Rn = V(() => import("./multiConversationDraftModal-CCbi9LwJ.js").then((e) => ({ default: e.MultiConversationDraftModal }))), zn = 6;
function Bn({ isError: e, isFetching: t, suggestionData: n, unableToFindTaggedSuggestions: r, suggestionsCount: i, hasSmartArticleCreate: a = !1, hasSmartArticleCreateMultiConversation: o = !1 }) {
	let { current: { searchTerm: s } } = v(C), c = n?.length || 0, { currentPage: l, totalPages: u, startIndex: d, endIndex: f, setPage: p } = Pe({
		totalItems: c,
		initialPageSize: zn
	}), m = De(() => (n || []).slice(d, f + 1), [
		f,
		d,
		n
	]);
	if (t || !n) return /* @__PURE__ */ R(dn, { resultsCount: i });
	if (e) throw Error("Error loading suggestions");
	if (n && !n.length) {
		let e = qe(s);
		return /* @__PURE__ */ R(fn, {
			headline: e ? "No results found" : "No suggestions found",
			description: e ? "Try using different keywords and avoid using short words like \"and\", \"as\", \"what\", \"is\", etc." : "Try searching for articles above, or try adding tags to the conversation."
		});
	}
	let h = l + 1;
	function g(e) {
		p(e - 1);
	}
	let _ = K({
		[Q.paginationWrapper]: m.length > zn,
		[Q.paginationStyles]: !0,
		[Q.paginationStyles__multiplePages]: u > 1
	});
	return /* @__PURE__ */ z(j, { children: [
		/* @__PURE__ */ R(Nn, {
			suggestions: m,
			beforeSlot: /* @__PURE__ */ R(Vn, { unableToFindTaggedSuggestions: r })
		}),
		/* @__PURE__ */ R(P, {
			justifyContent: "center",
			className: _,
			children: /* @__PURE__ */ R(ve, {
				currentPage: h,
				pageCount: u,
				onPageChange: g
			})
		}),
		/* @__PURE__ */ R(Hn, {
			hasSmartArticleCreate: a,
			hasSmartArticleCreateMultiConversation: o
		})
	] });
}
function Vn({ unableToFindTaggedSuggestions: e }) {
	return e ? /* @__PURE__ */ R(A, {
		variant: "info",
		description: /* @__PURE__ */ R(L, { children: "No suggestions were found matching your conversation tags, here are some suggestions based on the conversation body." }),
		className: Q.noArticlesFoundBanner
	}) : null;
}
function Hn({ hasSmartArticleCreate: e, hasSmartArticleCreateMultiConversation: t }) {
	let { showModal: n } = r(), { currentQueueId: i, currentConversationId: a } = v(S), o = t ? "multiple-conversations" : "single-conversation", { data: s } = te(), c = ({ articleName: e, articleContent: t, collectionId: r, languageId: i, conversationId: a }) => {
		let c = s?.collections.results.find((e) => e.id === r)?.title || "";
		q.conversationArticleDraftPreviewResponseReceived({
			collectionId: r,
			conversationId: a,
			languageCode: i,
			draftSource: o
		}), n(Ln, {
			languageId: i,
			articleName: e || "test",
			articleContent: t,
			collectionId: r,
			collectionName: c,
			conversationId: a
		});
	}, l = (e, t) => {
		Oe.captureException(e, { tags: { team: ke.Knowledge } }), n(In, { onRetry: t });
	}, [u] = ie(), d = g(), [f] = h({
		client: d,
		refetchQueries: [w]
	}), { data: p, loading: m } = ee({
		client: d,
		variables: { csid: a },
		skip: !t || !a,
		fetchPolicy: "network-only"
	}), _ = p?.aiDraftsByCsid ?? [], y = _.length > 0, b = (e) => {
		let r = e.collection[0]?.id ?? "", i = e.conversationId, a = e.language[0].id, s = () => (n(Fn, { children: /* @__PURE__ */ R(I.Paragraph, {
			variant: "2",
			children: "This may take a moment. You can close this modal or leave this page — your draft will continue being created in the background."
		}) }), q.conversationArticleDraftPreviewRequested({
			collectionId: r,
			conversationId: i,
			languageCode: a,
			draftSource: o
		}), t ? f({ variables: {
			csid: i,
			languageId: a
		} }).then(({ data: e }) => {
			let t = e?.aiDraftsGenerate;
			if (!t?.length) throw Error("No draft was generated");
			q.conversationArticleDraftPreviewResponseReceived({
				collectionId: r,
				conversationId: i,
				languageCode: a,
				draftSource: o
			}), n(Rn, {
				drafts: t,
				conversationId: i
			});
		}).catch((e) => l(e, s)) : u({
			csid: i,
			refresh: !1,
			save_draft_article_input: { collection_id: r },
			language_id: a
		}).then(c).catch((e) => l(e, s)));
		return s();
	}, x = () => {
		y ? n(Rn, {
			drafts: _,
			conversationId: a
		}) : n(Pn, {
			onSubmit: b,
			queueId: i,
			withCollection: !t
		});
	};
	if (!e && !t) return null;
	let C = t ? "multiConversationArticleDraftButton" : void 0, T = _.length > 1 ? "Read AI drafts" : y ? "Read AI draft" : "Create auto draft with AI";
	return !s?.collections?.results.length && !y ? /* @__PURE__ */ R(j, {
		margin: "0 0 400",
		children: /* @__PURE__ */ R(be, {
			content: /* @__PURE__ */ z(P, {
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				children: [/* @__PURE__ */ R(j, { children: "Contact your admin to access this collection" }), /* @__PURE__ */ R(j, { children: "and begin creating auto drafts with AI." })]
			}),
			wrap: "div",
			className: Q.aiButtonTooltipWrapper,
			children: /* @__PURE__ */ R(fe, {
				variant: "tertiary",
				icon: "ai",
				disabled: !0,
				className: Q.aiButton,
				"data-testid": C,
				children: T
			})
		})
	}) : /* @__PURE__ */ R(j, {
		margin: "0 0 400",
		children: /* @__PURE__ */ R(fe, {
			variant: "tertiary",
			className: Q.aiButton,
			icon: "ai",
			"data-testid": C,
			isLoading: m,
			disabled: m,
			onClick: x,
			children: T
		})
	});
}
var $ = {
	searchInput: "_searchInput_m2v9h_1",
	searchInputFetching: "_searchInputFetching_m2v9h_9",
	spinner: "_spinner_m2v9h_14",
	suggestionsNotFoundWrapper: "_suggestionsNotFoundWrapper_m2v9h_18",
	suggestionsNotFound: "_suggestionsNotFound_m2v9h_18",
	suggestionsNotFoundContent: "_suggestionsNotFoundContent_m2v9h_30"
}, Un = We((e) => {
	_.setSearchTermForCurrentConversation(e);
}, 500);
function Wn({ conversationTags: e, conversationText: t, hasSmartReply: n, featureFlags: r, selectedLanguageId: i }) {
	let [a, o] = G(""), [s, c] = G(3), { currentConversationId: l, suggestionState: u, currentQueueId: d } = v(S), { current: { searchTerm: f } } = v(C), p = u[l], { error: m, loading: h, suggestions: g, unableToFindTaggedSuggestions: _, unableToFindLinkedCollections: y, noQueue: b } = Qe({
		conversationTags: e,
		conversationText: t,
		searchTerm: f,
		queueId: d,
		selectedLanguageId: i
	});
	if (U(() => (Un(a), () => {
		Un.cancel();
	}), [a]), U(() => {
		o(u[l]?.searchTerm || "");
	}, [l]), U(() => {
		g && c(g.length);
	}, [g]), b) return /* @__PURE__ */ R(Gn, {});
	if (y) return /* @__PURE__ */ R(Kn, {});
	let x = !!m;
	if (m) return /* @__PURE__ */ R(Ue, { message: m.message });
	if (p?.articleId && p?.articleCollectionId) return /* @__PURE__ */ R(xn, {
		id: p.articleId,
		languageId: i,
		collectionId: p.articleCollectionId,
		hasSmartReply: n
	});
	let w = K($.searchInput, { [$.searchInputFetching]: h });
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(_e, {
		className: w,
		onChange: (e) => o(e.currentTarget.value),
		value: a,
		placeholder: "Search for help...",
		icon: "search"
	}), /* @__PURE__ */ R(Bn, {
		suggestionData: g,
		isError: x,
		isFetching: h,
		unableToFindTaggedSuggestions: _,
		suggestionsCount: s,
		hasSmartArticleCreate: r.hasSmartArticleCreate,
		hasSmartArticleCreateMultiConversation: r.hasSmartArticleCreateMultiConversation
	})] });
}
function Gn() {
	return /* @__PURE__ */ R(j, {
		className: $.suggestionsNotFoundWrapper,
		children: /* @__PURE__ */ R(A, {
			className: $.suggestionsNotFound,
			variant: "warning",
			headline: "No queue assigned",
			description: /* @__PURE__ */ R(I.Paragraph, {
				subdued: !0,
				variant: "4",
				className: $.suggestionsNotEnabledContent,
				children: "This conversation is not assigned to a queue. To see suggestions, assign the conversation to a queue that is linked to a knowledge collection."
			})
		})
	});
}
function Kn() {
	return /* @__PURE__ */ R(j, {
		className: $.suggestionsNotFoundWrapper,
		children: /* @__PURE__ */ R(A, {
			className: $.suggestionsNotFound,
			variant: "warning",
			headline: "No linked knowledge collection",
			description: /* @__PURE__ */ R(I.Paragraph, {
				subdued: !0,
				variant: "4",
				className: $.suggestionsNotEnabledContent,
				children: /* @__PURE__ */ z(L, { children: [
					"To see suggestions, this queue needs to be linked to a collection.",
					" ",
					/* @__PURE__ */ R("br", {}),
					/* @__PURE__ */ R("br", {}),
					/* @__PURE__ */ R("span", { children: "Visit the Knowledge management console to link a collection to this queue. If you do not have access to the console, please contact your administrator." })
				] })
			})
		})
	});
}
// src/agentInterfaceSuggestions.tsx
var qn = /* @__PURE__ */ R(de, {
	icon: "file-text",
	color: {
		backgroundColor: "var(--dixa-color-neutral-200)",
		contentColor: "var(--dixa-typography-color-tertiary)"
	}
});
function Jn({ conversationId: e, conversationTags: n, conversationText: r, isMinimized: i, isOpen: a, queueId: o, setIsOpen: s, featureFlags: c, notify: l, slotAfterTitle: u, getDragHandle: d, renderSourceConversations: p }) {
	if (i) return /* @__PURE__ */ R("div", {
		className: "icon-holder",
		children: qn
	});
	let m = ze();
	return /* @__PURE__ */ R(oe, {
		client: m,
		children: /* @__PURE__ */ R(t.Provider, {
			value: l,
			children: /* @__PURE__ */ R(O, {
				value: p,
				children: /* @__PURE__ */ R(f, { children: /* @__PURE__ */ R(Yn, {
					conversationId: e,
					conversationTags: n,
					conversationText: r,
					isOpen: a,
					setIsOpen: s,
					featureFlags: c,
					queueId: o,
					slotAfterTitle: u,
					getDragHandle: d
				}) })
			})
		})
	});
}
function Yn({ conversationId: e, conversationTags: t, conversationText: n, featureFlags: r, isOpen: i, setIsOpen: a, queueId: o, slotAfterTitle: s, getDragHandle: c }) {
	let l = W(null), { selectedLanguageId: u } = v(E);
	U(() => {
		_.setConversationId(e);
	}, [e]), U(() => {
		_.setQueueId(o);
	}, [o]);
	let { data: d, loading: f } = ne({
		selectedLanguageId: u,
		onCompleted: (e) => {
			u && e?.organisationSettings.enabledLanguages.find((e) => e.languageId === u) || D(e.organisationSettings.defaultLanguage.languageId);
		}
	});
	return f || !d || !u ? /* @__PURE__ */ z(N, {
		containerRef: l,
		onToggle: Ae,
		isOpen: i,
		children: [/* @__PURE__ */ R(N.Header, {
			avatar: qn,
			slotAfterTitle: s,
			slotBeforeTitle: c?.(l),
			children: "Articles"
		}), /* @__PURE__ */ R(N.Content, { children: /* @__PURE__ */ R(j, {
			padding: "300",
			children: /* @__PURE__ */ R(I.Paragraph, {
				subdued: !0,
				children: "Initializing..."
			})
		}) })]
	}) : /* @__PURE__ */ R(Xn, {
		conversationId: e,
		conversationTags: t,
		conversationText: n,
		featureFlags: r,
		isOpen: i,
		setIsOpen: a,
		languageData: d,
		queueId: o,
		slotAfterTitle: s,
		getDragHandle: c
	});
}
function Xn({ conversationId: e, conversationTags: t, conversationText: n, featureFlags: r, isOpen: i, setIsOpen: a, languageData: o, slotAfterTitle: s, getDragHandle: c }) {
	let l = W(null);
	function u() {
		a(!i);
	}
	let { selectedLanguage: d, defaultLanguage: f } = o, p = o.defaultLanguage.languageId === d.languageId, m = `${d.description}${p ? " (Default)" : ""}`;
	return /* @__PURE__ */ z(N, {
		containerRef: l,
		onToggle: u,
		isOpen: i,
		children: [/* @__PURE__ */ R(N.Header, {
			dropdown: /* @__PURE__ */ R(Be, {
				languageData: o,
				selectedLanguageId: d.languageId,
				setSelectedLanguageId: D
			}),
			dropdownTrigger: /* @__PURE__ */ R(be, {
				content: m,
				children: /* @__PURE__ */ R(F, { name: "translate" })
			}),
			avatar: qn,
			slotBeforeTitle: c?.(l),
			slotAfterTitle: s,
			children: "Articles"
		}), /* @__PURE__ */ R(N.Content, { children: /* @__PURE__ */ R(Ve, {
			fallback: ({ error: e }) => /* @__PURE__ */ R(Ue, { message: e instanceof Error ? e.message : "An error has occurred. Please try again." }),
			children: /* @__PURE__ */ R(Wn, {
				conversationId: e,
				conversationTags: t,
				conversationText: n,
				hasSmartReply: r.hasSmartReply,
				featureFlags: r,
				selectedLanguageId: d?.languageId || f.languageId
			})
		}) })]
	});
}
// src/index.ts
var Zn = Jn;
export { Zn as default };

//# sourceMappingURL=index.js.map